<template>
  <div class="core-box">
    <img src="@/assets/home/idea_bg.png" alt="" />
    <div class="core-content">
      <div class="en-title">VALUES</div>
      <div class="cn-title">价值观</div>
      <div class="core-item" v-for="(item, index) in itemList" :key="index">
        <div class="item-title">{{ item.title }}</div>
        <div class="item-mark">{{ item.content }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      itemList: [
        {
          title: "经营使命",
          content: "减少企业试错成本让每一个项目都能落地。",
        },
        {
          title: "核心价值观",
          content: "不夸大，说真话，克己慎独，不盲从。",
        },
        {
          title: "企业精神",
          content: "正人做正事，真人真本事。",
        },
        {
          title: "经营理念",
          content: "近悦远来，长期主义，知行合一。",
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
@import url("./index.scss");
</style>
